import { Component, Input } from '@angular/core';
import { AccountGroup } from '@galaxy/account-group';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'orders-company-name',
  styleUrls: ['../order-details.component.scss'],
  template: `
    <div class="column">
      <span class="column-title">
        {{ 'LIB_ORDERS.COMMON.ORDER_DETAILS.COMPANY' | translate }}
      </span>
      <span class="column-content">
        <a [href]="url" target="_blank" rel="noopener noreferrer">
          {{ business?.napData?.companyName }}
        </a>
      </span>
    </div>
  `,
  imports: [TranslateModule],
})
export class CompanyNameComponent {
  @Input() business: Pick<AccountGroup, 'napData'>;
  @Input() url?: string;
}
